import React, { createContext, useState } from 'react';

export const WaitlistContext = createContext({
  email: '',
  setEmail: () => {}
});

export const WaitlistProvider = ({ children }) => {
  const [email, setEmail] = useState('');
  return (
    <WaitlistContext.Provider value={{ email, setEmail }}>
      {children}
    </WaitlistContext.Provider>
  );
};

export default WaitlistProvider;
